import * as tslib_1 from "tslib";
import { Tooltip } from "@h3/antd-vue";
import { Component, Model, Prop, Vue } from "vue-property-decorator";
import conduct from "./../conduct";
let H3InputNumber = class H3InputNumber extends Vue {
    constructor() {
        super(...arguments);
        this.tips = '请输入不超过15个数字';
        this.focused = false;
        this.tooltipVisible = false;
    }
    get inputStyle() {
        let left = '11px';
        if (this.focused && this.isMoneyNumber()) {
            if (this.isMobile) {
                if (this.isMoneyNumber().length === 1) {
                    left = '11px !important';
                }
                else {
                    left = '28px !important';
                }
            }
            else {
                if (this.isMoneyNumber().length === 1) {
                    left = '22px';
                }
                else {
                    left = '40px';
                }
            }
        }
        return {
            'padding-left': left
        };
    }
    get inputValue() {
        const val = typeof this.value === 'number' ? this.value.toString() : '';
        return val;
    }
    onFocus(evt) {
        this.focused = true;
        this.$emit('focus', evt);
    }
    onBlur(evt) {
        this.focused = false;
        this.$emit('blur', evt);
        this.tooltipVisible = false;
    }
    stepUp() {
        if (this.value !== null) {
            const val = this.value + this.step;
            this.$emit('change', val);
        }
    }
    stepDown() {
        if (this.value !== null) {
            const val = this.value - this.step;
            this.$emit('change', val);
        }
    }
    // 获取控件数值格式
    getNumberType() {
        const formatList = conduct.properties.format1.options.list;
        const format = this.controlOpts.format1;
        let label = '';
        for (let index = 0; index < formatList.length; index++) {
            const element = formatList[index];
            if (element.value === format) {
                label = element.label;
                break;
            }
        }
        return label;
    }
    // 控件是否百分比值
    isPercentage() {
        return this.getNumberType().indexOf('%') > -1;
    }
    // 其他前置符号
    isMoneyNumber() {
        let numberType = this.getNumberType();
        let matchMoney = numberType.match(/^[^\d]+/);
        let res = matchMoney && matchMoney[0];
        if (res === '空') {
            res = '';
        }
        return res;
    }
    onChange(evt) {
        const inputVal = evt.target.value;
        if (inputVal !== "-" && inputVal * 1 !== inputVal * 1) { // 输入的不是数值类型
            this.tips = `请输入正确内容`;
            this.tooltipVisible = true;
        }
        else {
            this.tooltipVisible = false;
        }
        var val = /^-?\d+(\.{1}\d*)?$/.test(inputVal) ? Number(inputVal) : null;
        if (val) {
            let numberType = this.getNumberType();
            let decimal = numberType ? numberType.split('.')[1] ? numberType.split('.')[1].length : 0 : 0;
            let inter = inputVal.split('.');
            if (~numberType.indexOf('%')) { // 百分比类型，小数位数量减1
                decimal -= 1;
            }
            if (numberType === '空') {
                const num = inter[1] ? 17 : 16;
                if (inputVal.length > num || (inter[1] && inter[1].length > 8)) {
                    this.tips = '最大长度16位，精度8位（8位小数）';
                    this.tooltipVisible = true;
                    inter[0] = inter[0].slice(0, 16);
                    const count = 16 - inter[0].length;
                    if (inter[1])
                        inter[1] = inter[1].slice(0, count > 8 ? 8 : count);
                    val = +inter.join('.');
                    evt.target.value = val + '';
                }
                else {
                    this.tooltipVisible = false;
                }
            }
            else if (decimal) { // 控件是小数格式
                const num = inter[1] ? 17 : 16;
                if (inputVal.length > num) {
                    this.tips = `最大长度16位，精度${decimal}位（${decimal}位小数)`;
                    this.tooltipVisible = true;
                    inter[0] = inter[0].slice(0, 16);
                    const count = 16 - inter[0].length;
                    if (inter[1])
                        inter[1] = inter[1].slice(0, count > 8 ? 8 : count);
                    val = inter.join('.');
                    evt.target.value = val + '';
                }
                else if (inter[1] && inter[1].length > decimal) {
                    this.tips = `小数点后请输入不超过${decimal}位`;
                    this.tooltipVisible = true;
                    inter[1] = inter[1].slice(0, decimal);
                    val = inter.join('.');
                    console.log('val小数超位===>', val);
                    evt.target.value = val + '';
                    console.log('val小数超位2===>', evt.target.value);
                }
                else if (inter[0].length > 16) {
                    this.tips = '请输入不超过16个数字';
                    this.tooltipVisible = true;
                    inter[0] = inter[0].slice(0, 16);
                    val = inter.join('.');
                    evt.target.value = val + '';
                }
                else {
                    this.tooltipVisible = false;
                }
            }
            else {
                // 正数最大只能输入 16位
                if (inter[0].length > 16) {
                    this.tips = '请输入不超过16个数字';
                    this.tooltipVisible = true;
                    inter[0] = inter[0].slice(0, 16);
                    val = inter.join('.');
                    evt.target.value = val + '';
                    console.log(val);
                }
                else {
                    this.tooltipVisible = false;
                }
            }
        }
        this.$emit('change', val);
    }
    mounted() {
        this.$nextTick(() => {
            const input = this.$el.querySelector("input");
            if (input) {
                this.$emit('format', input);
            }
        });
    }
};
tslib_1.__decorate([
    Prop({
        default: ''
    })
], H3InputNumber.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], H3InputNumber.prototype, "disabled", void 0);
tslib_1.__decorate([
    Model('change')
], H3InputNumber.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        default: 1
    })
], H3InputNumber.prototype, "step", void 0);
tslib_1.__decorate([
    Prop({
        default: () => []
    })
], H3InputNumber.prototype, "ctrl", void 0);
tslib_1.__decorate([
    Prop({
        default: {}
    })
], H3InputNumber.prototype, "controlOpts", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], H3InputNumber.prototype, "isMobile", void 0);
H3InputNumber = tslib_1.__decorate([
    Component({
        name: "h3-input-number",
        components: {
            ATooltip: Tooltip
        }
    })
], H3InputNumber);
export default H3InputNumber;
